import { Aktenzeichen } from './aktenzeichen.model';
import { AktenzeichenRenderer } from './aktenzeichen-renderer';
import { AktenzeichenUtil } from './aktenzeichen-util.service';

export class ShortAktenzeichenRenderer extends AktenzeichenRenderer {
	render(aktenzeichen: Aktenzeichen | string): string {
		if (typeof aktenzeichen === 'string') {
			aktenzeichen = AktenzeichenUtil.parse(aktenzeichen);
		}

		const register = AktenzeichenUtil.getRegister(aktenzeichen);
		const blattNummer = AktenzeichenUtil.getBlattNummer(aktenzeichen);

		return register + ' ' + blattNummer;
	}
}
